<template>
  <div>

    <van-sticky>
      <van-nav-bar
        title="添加预约场馆"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>
    <van-form @submit="onSubmit">
      <van-field
        clearable
        v-model="vname"
        name="vname"
        label="场馆名"
        placeholder="场馆名"
        :rules="[{ required: true, message: '请填写场馆名' }]"
      />

      <!--      <van-cell title="第几周">-->
      <!--        <van-stepper theme="round" max="18" v-model="week" integer/>-->
      <!--      </van-cell>-->
      <!--      <van-cell title="周几">-->
      <!--        <van-stepper theme="round" max="7" v-model="day" integer/>-->
      <!--      </van-cell>-->


      <van-cell title="最大人数">
        <van-stepper theme="round" v-model="maxp" integer/>
      </van-cell>

      <van-field
        clearable
        v-model="location"
        name="location"
        label="场馆位置"
        placeholder="场馆位置"
        :rules="[{ required: true, message: '请填写场馆位置' }]"
      />

      <van-field
        v-model="notice"
        rows="2"
        autosize
        name="notice"
        clearable
        label="场馆公告"
        type="textarea"
        maxlength="500"
        placeholder="场馆公告"
        show-word-limit
        :rules="[{ required: true, message: '请填写场馆公告' }]"
      />

      <van-divider>预约学生限制条件列表</van-divider>

      <van-cell-group inset>
        <van-cell v-for="(item,index) in conditions" :title="'条件'+(index+1)" :key="index">
          <template #label>
            <p> 年级:{{ item.grade.toString() }}</p>
            <p> 学院(部):{{ item.school.toString() }}</p>
            <p> 层次:{{ item.level.toString() }}</p>
          </template>
          <template #right-icon>
            <van-button type="warning" size="mini" @click="delCondition(index)">删除</van-button>
          </template>
        </van-cell>
      </van-cell-group>
      <div style="padding: 20px;text-align: center;font-weight: bolder;">
        <div @click="conditionShow=true">添加条件</div>
      </div>

      <van-field
        readonly
        clickable
        :value="startTime"
        name="startTime"
        label="体测预约时间"
        placeholder="点击选择体测预约开始时间"
        @click="startTimeShowPicker = true"
      />

      <van-popup v-model="startTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate1"
          type="datetime"
          title="场馆开始预约时间"
          @confirm="startOnConfirm"
          @cancel="startTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        :value="openTime"
        name="openTime"
        label="场馆开放时间"
        placeholder="点击选择场馆开放时间"
        @click="openTimeShowPicker = true"
      />

      <van-popup v-model="openTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate2"
          type="time"
          title="选择场馆开放时间"
          @confirm="OpenOnConfirm"
          @cancel="openTimeShowPicker = false"
        />
      </van-popup>

      <van-field
        readonly
        clickable
        :value="closeTime"
        name="closeTime"
        label="场馆关闭时间"
        placeholder="点击选择场馆关闭时间"
        @click="closeTimeShowPicker = true"
      />

      <van-popup v-model="closeTimeShowPicker" position="bottom">
        <van-datetime-picker
          v-model="currentDate3"
          type="time"
          title="选择场馆关闭时间"
          @confirm="closeOnConfirm"
          @cancel="closeTimeShowPicker = false"
        />
      </van-popup>

      <van-cell title="选择日期" :value="calendarText" @click="calendarShow = true"/>
      <van-calendar :min-date="minDate" :max-date="maxDate" v-model="calendarShow" type="multiple"
                    @confirm="onCalendarConfirm"/>

      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">
          添加场馆
        </van-button>
      </div>
    </van-form>
    <van-dialog v-model="conditionShow" title="选择添加" confirmButtonText="添加" show-cancel-button @confirm="addCondition">
      <van-divider content-position="left">测试对象年级</van-divider>
      <van-checkbox-group class="checkbox-group" v-model="gradeValue" direction="horizontal">
        <van-checkbox class="checkbox" :name="item" v-for="(item,index) in grade" :key="index">{{
            item
          }}
        </van-checkbox>
      </van-checkbox-group>
      <van-divider content-position="left">测试对象学院(部)</van-divider>
      <van-checkbox-group class="checkbox-group" v-model="schoolValue" direction="horizontal">
        <van-checkbox class="checkbox" checked-color="#fcd217" :name="item" v-for="(item,index) in school"
                      :key="index">{{
            item
          }}
        </van-checkbox>
      </van-checkbox-group>
      <van-divider content-position="left">测试对象学历层次</van-divider>
      <van-checkbox-group style="margin-bottom: 30px" class="checkbox-group" v-model="levelValue"
                          direction="horizontal">
        <van-checkbox class="checkbox" checked-color="#8cc269" :name="item" v-for="(item,index) in level"
                      :key="index">{{
            item
          }}
        </van-checkbox>
      </van-checkbox-group>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Form,
  Field,
  Button,
  Picker,
  Popup,
  Dialog,
  Col,
  Row,
  DatetimePicker,
  Uploader,
  Stepper,
  CellGroup,
  Cell,
  Sticky,
  RadioGroup, Radio,
  Calendar,
  Checkbox,
  CheckboxGroup,
  Divider
} from 'vant';

Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Dialog);
Vue.use(Col);
Vue.use(Row);
Vue.use(DatetimePicker);
Vue.use(Uploader);
Vue.use(Stepper);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Sticky);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Calendar);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Divider);
import {AddPhyTest} from "../../../../network/test_booking";

export default {
  name: "AddTestBooking",
  data() {
    return {
      //Venue Name
      vname: '',

      // 添加条件
      conditionShow: false,

      //Maximum number of people
      maxp: 1,

      //location
      location: "",

      //notice
      notice: "",
      // 年级
      // gradeValue: ['2021', '2020', '2019', '2018', '2017'],
      gradeValue: [],
      grade: ['2021', '2020', '2019', '2018', '2017'],
      // 学院(部)
      schoolValue: ['工学部', '艺体学部', '医学部','商学部', '医学部', '商学部', '国际学院', '外国语学院', '应用技术学院', '职业技术学院'],
      school: ['工学部', '艺体学部', '医学部','商学部', '医学部', '商学部', '国际学院', '外国语学院', '应用技术学院', '职业技术学院'],
      // 学历层次
      // levelValue: ['本科', '专科', '专升本'],
      levelValue: [],
      level: ['本科', '专科', '专升本'],
      // 条件序列
      conditions: [],
      //Rush venue time
      startTime: "",
      startUnixTime: "",
      startTimeShowPicker: false,
      currentDate1: new Date(),

      //open venue time
      openTime: "",
      openTimeShowPicker: false,
      currentDate2: '',

      //close venue time
      closeTime: "",
      closeTimeShowPicker: false,
      currentDate3: '',

      //Calendar 日历
      calendarShow: false,
      calendarText: '',
      calendarDate: [],
      minDate: new Date(),
      maxDate: this.GLOBAL.end_select_time,
    }
  },
  activated() {
    const years = this.GLOBAL.years;
    this.grade = [];
    for (let i = 0; i < 6; i++) {
      this.grade.push(years - i);
    }

  },
  methods: {
    Dialoginfo(title, message) {
      Dialog.alert({
        title,
        message
      }).then(() => {
        // on close
      });
    }
    ,
    onClickLeft() {
      // this.$router.back(-1);
      this.$router.replace("TestBookingManageList");
    },
    startOnConfirm(value) {
      this.startTime = value.toLocaleString();
      this.startUnixTime = value.getTime();
      this.startTimeShowPicker = false;
    },
    OpenOnConfirm(value) {
      this.openTime = value;
      this.openTimeShowPicker = false;
    },
    closeOnConfirm(value) {
      this.closeTime = value;
      // console.log(this.closeTime);
      this.closeTimeShowPicker = false;
    },
    onCalendarConfirm(date) {
      this.calendarDate = date;
      this.calendarShow = false;
      this.calendarText = `选择了 ${date.length} 个日期`;
    },
    timeCompare(time1, time2) {
      let split1 = time1.split(':');
      let split2 = time2.split(':');
      if (parseInt(split1[0]) > parseInt(split2[0])) {
        return true;
      } else if (parseInt(split1[0]) === parseInt(split2[0])) {
        if (parseInt(split1[1]) > parseInt(split2[1])) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    clearDate(dates) {
      for (let i = 0; i < dates.length; i++) {
        dates[i].setHours(0);
        dates[i].setMinutes(0);
        dates[i].setSeconds(0);
      }
      return dates;
    },
    getUnix(time) {
      let split = time.split(':');
      return 1000 * 60 * (parseInt(split[0]) * 60 + parseInt(split[1]))
    },
    addCondition() {
      if (this.gradeValue.length == 0) {
        this.Dialoginfo('提示', '年级不能为空');
        return
      }
      if (this.schoolValue.length == 0) {
        this.Dialoginfo('提示', '学院(部)不能为空');
        return
      }
      if (this.levelValue.length == 0) {
        this.Dialoginfo('提示', '层次不能为空');
        return
      }
      this.conditions.push({grade: this.gradeValue, school: this.schoolValue, level: this.levelValue});
      this.gradeValue = [];
      this.levelValue = [];
    },
    delCondition(index) {
      this.conditions.splice(index, 1);
    },
    onSubmit(values) {
      if (values.vname === ":") {
        this.Dialoginfo('提示', '场馆名不能为空');
      } else if (this.grade.length < 1) {
        this.Dialoginfo('提示', '年级至少选择一个');
      } else if (this.school.length < 1) {
        this.Dialoginfo('提示', '学院(部)至少选择一个');
      } else if (this.level.length < 1) {
        this.Dialoginfo('提示', '学历层次至少选择一个');
      } else if (values.location === "") {
        this.Dialoginfo('提示', '位置不能为空');
      } else if (values.notice === "") {
        this.Dialoginfo('提示', '公告不能为空');
      } else if (this.startTime === "") {
        this.Dialoginfo('提示', '开始预约时间不能为空');
      } else if (this.openTime === "") {
        this.Dialoginfo('提示', '场馆开放时间不能为空');
      } else if (this.closeTime === "") {
        this.Dialoginfo('提示', '场馆关闭时间不能为空');
      } else if (this.calendarText === "") {
        this.Dialoginfo('提示', '日期不能为空');
      } else if (!this.timeCompare(this.closeTime, this.openTime)) {
        this.Dialoginfo('提示', '场馆关闭时间应该大于开放时间');
      } else if (this.conditions.length == 0) {
        this.Dialoginfo('提示', '预约学生限制条件列表不能为空');
      } else {
        // 生成条件序列
        let condition = "";
        const conditions = this.conditions;
        for (let i = 0; i < conditions.length; i++) {
          condition += conditions[i].grade + '-';
          condition += conditions[i].school + '-';
          condition += conditions[i].level;
          if (i != conditions.length - 1) {
            condition += ":"
          }
        }

        let date = this.clearDate(this.calendarDate);
        let dates = "";
        for (let i = 0; i < date.length; i++) {
          dates = dates + date[i].getTime();
          if (i != date.length - 1)
            dates = dates + ':';
        }
        let times = new Date();

        let open = this.getUnix(this.openTime);
        let close = this.getUnix(this.closeTime);
        AddPhyTest(values.vname, values.location, values.notice, this.maxp, condition, this.startUnixTime, open, close, dates).then(res => {
          if (res.status) {
            let msg = res.success.join() + '添加成功;';
            if (res.fail.length > 0)
              msg = msg + res.fail.join() + '添加失败';
            this.Dialoginfo('提示', '添加完成,' + msg);
          } else {
            this.Dialoginfo('提示', '添加失败');
          }
        }).catch(res => {
          this.Dialoginfo('提示', '添加失败');
        })
      }
    }
  }
}
</script>

<style scoped>
.checkbox-group {
  padding: 0 20px;
}

.checkbox {
  margin: 0 0 5px 5px;
}
</style>
